let dark = '#000000',
    light = '#ffffff';

//Example use: ${props => props.theme.primaryColor};

export default {
    // Base
    dark: dark,
    light: light,

    // Primary
        primary: '#7c4dff',
        primaryColor: light,

        primaryLight: '#b47cff',
        primaryLightColor: dark,

        primaryDark: '#3f1dcb',
        primaryDarkColor: light,

        primaryDarkMedium: '#5835e8',
        primaryDarkMediumColor: light,

    //Secondary
        secondary: '#80cbc4',
        secondaryColor: dark,
        
        secondaryLight: '#b2fef7',
        secondaryLightColor: dark,
        
        secondaryDark: '#4f9a94',
        secondaryDarkColor: dark
};


// WEBPACK FOOTER //
// ./src/styles/colors.js